import { jwtDecode, JwtPayload } from "jwt-decode";
import _ from "lodash";
import { BackofficeUser, Roles } from "../types/BackofficeUser";
import { arrayUtils } from "./utils";

export const loginToken = (token: string) => {
  localStorage.setItem("legalbirdServicesJWT", token);
};

export const logoutToken = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const loadToken = () => {
  return localStorage.getItem("legalbirdServicesJWT");
};

const IMPERSONATE_ROLES = [Roles.admin, Roles.productManager, Roles.developer];

export const checkToken = (token: string | null, currentUser: BackofficeUser | null) => {
  if (!_.isString(token) || token.length === 0 || !currentUser) {
    return false;
  }

  type customJwtPayload = {
    username: string;
    roles: BackofficeUser["roles"];
  } & JwtPayload;
  try {
    const decodedToken = jwtDecode<customJwtPayload>(token);
    return (
      (decodedToken.username === currentUser.email || arrayUtils.getArraysIntersect(decodedToken.roles, IMPERSONATE_ROLES)) &&
      decodedToken?.exp &&
      decodedToken.exp > Date.now() / 1000
    );
  } catch (err) {
    return false;
  }
};
